module.exports = __webpack_public_path__ + "img/reading2.58d6e94f.png";